import { render, staticRenderFns } from "./TenantDetails.vue?vue&type=template&id=25d2cf36"
import script from "./TenantDetails.vue?vue&type=script&lang=js"
export * from "./TenantDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports